<span [class]="hostClass()" [attr.aria-label]="ariaLabel()">{{ displayText() }}</span>
